import React, {Component} from 'react'
import PropTypes from 'prop-types'
import objectFitImages from 'object-fit-images'

import {imageList} from '../../../assets/images'
import {StyledPicture, StyledImg} from './styles'

class Picture extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    mobile: PropTypes.string,
    objectFit: PropTypes.string,
    objectPosition: PropTypes.string,
    blur: PropTypes.number,
  }

  static defaultProps = {
    mobile: null,
    objectFit: null,
    objectPosition: 'center',
    blur: null,
  }

  constructor() {
    super()
    this.imgRef = React.createRef()
  }

  componentDidMount() {
    const {objectFit} = this.props
    if (objectFit) {
      objectFitImages(this.imgRef.current)
    }
  }

  render() {
    const {name, alt, mobile, objectFit, objectPosition, ...restProps} = this.props
    const {jpg, webp} = imageList[name]
    const jpgMobile = mobile ? imageList[mobile].jpg : []
    const webpMobile = mobile ? imageList[mobile].webp : []
    let media = '(max-width: 1200px)'
    if (mobile) {
      media = `${media} and (min-width: 992px)`
    }

    return (
      <StyledPicture {...restProps}>
        <source
          srcSet={`${webp[0]}, ${webp[1]} 2x, ${webp[2]} 3x`}
          type="image/webp"
          media={media}
        />
        <source srcSet={`${jpg[0]}, ${jpg[1]} 2x, ${jpg[2]} 3x`} type="image/jpeg" media={media} />
        <source
          srcSet={`${webp[1]}, ${webp[2]} 2x, ${webp[2]} 3x`}
          type="image/webp"
          media="(min-width: 1200px)"
        />
        <source
          srcSet={`${jpg[1]}, ${jpg[2]} 2x, ${jpg[2]} 3x`}
          type="image/jpg"
          media="(min-width: 1200px)"
        />
        {mobile && (
          <>
            <source
              srcSet={`${webpMobile[0]}, ${webpMobile[1]} 2x, ${webpMobile[2]} 3x`}
              type="image/webp"
              media="(max-width: 992px)"
            />
            <source
              srcSet={`${jpgMobile[0]}, ${jpgMobile[1]} 2x, ${jpgMobile[2]} 3x`}
              type="image/jpg"
              media="(max-width: 992px)"
            />
          </>
        )}
        <StyledImg
          src={jpg[0]}
          alt={alt}
          ref={this.imgRef}
          objectFit={objectFit}
          objectPosition={objectPosition}
        />
      </StyledPicture>
    )
  }
}

export default Picture
